import { AnalyticEventType } from "./AnalyticEventType";

export class BaseAnalyticEvent {
    public readonly eventType: AnalyticEventType;
    public readonly eventId: string;

    public constructor(eventType: AnalyticEventType, eventId?: string) {
        this.eventType = eventType;
        this.eventId = eventId;
    }
}
